import { getRandomBetween } from "../utils";
import { HiveClass } from "./hiveClass";

export default function createFurdland(
  pos,
  beeFrameAmount,
  broodFrameAmount,
  id
) {
  const now = new Date().getTime();
  let beeFrames = [];
  let broodFrames = [];
  const pattern = getRandomBetween(0.1, 0.99);
  for (let i = 0; i < beeFrameAmount; i++) {
    beeFrames.push({ stageDate: now });
  }
  for (let i = 0; i < broodFrameAmount; i++) {
    let index = 9 - i;
    if (index < 0) {
      index = 0;
    }

    broodFrames.push({ index: index, stageDate: now, spotty: 1 - pattern });
  }
  const layingVigor = getRandomBetween(0.1, 0.99);
  const honey = getRandomBetween(0.1, 0.99);
  const diseaseResistance = getRandomBetween(0.1, 0.99);
  const swarmTendency = getRandomBetween(0.1, 0.99);
  const aggression = getRandomBetween(0.1, 0.99);
  const miteResistance = getRandomBetween(0.1, 0.99);
  const overWinter = getRandomBetween(0.1, 0.99);

  let queenStats = {
    haveQueen: true,
    layingVigor: layingVigor,
    pattern: pattern,
    honey: honey,
    diseaseResistance: diseaseResistance,
    swarmTendency: swarmTendency,
    droneTendency: 0.05,
    aggression: aggression,
    virgin: false,
    laying: true,
    miteResistance: miteResistance,
    overwinter: overWinter,
    breed: "Furdland",
    birth: now,
  };
  return new HiveClass(
    id,
    { count: 10, queenAccess: 10, boxes: 1 },
    {
      count: beeFrameAmount,
      frames: beeFrames,
    },
    {
      count: broodFrameAmount,
      frames: broodFrames,
    },
    1 - queenStats.pattern,
    { count: 0, cells: [], type: null, lastChecked: now },
    0,
    { count: 0, daysAt0: 0 },
    { count: 0, frames: [] },
    0.4,
    1,
    {
      miteSymptoms: 0,
      efb: false,
      afb: false,
      broodDisease: false,
    },
    0.8,
    queenStats,
    now,
    true,
    now,
    pos,
    []
  );
}
